module.exports = __webpack_public_path__ + "img/tuidingqueren.509f4211.svg";